import { differenceInCalendarDays } from 'date-fns';

export const getCalendarDaysToDate = (date: Date | string, fromDate: Date = new Date()): number => {
    return differenceInCalendarDays(new Date(date), fromDate);
}
